// extracted by mini-css-extract-plugin
export var active = "_2r-b";
export var activeIndicator = "_2r-6";
export var animate = "_2r-a";
export var disabled = "_2r-c";
export var flat = "_2r-1";
export var fullWidth = "_2r-3";
export var lg = "_2r-9";
export var md = "_2r-8";
export var redoButtonTabGroup = "_2r-0";
export var sm = "_2r-7";
export var tabButton = "_2r-4";
export var tabButtonsContainer = "_2r-2";
export var xs = "_2r-5";